<template>
    <div data-cy="container_campaign_detail_condition">
        <div class="flex mt-5" data-cy="container_campaign_tabs">
            <div class="py-1 px-4 cursor-pointer w-full text-center"
                 data-cy="btn_campaign_tab_detail"
                 :class="[active == 'detail' ? 'text-a-blue-2140a6 border-b border-a-blue-2140a6' : 'text-a-gray-a4a4a4']"
                 @click="clickTab('detail')">
                {{lbl.detail.detail}}
            </div>
            <div class="py-1 px-4 cursor-pointer w-full text-center"
                 data-cy="btn_campaign_tab_condition"
                 :class="[active == 'condition' ? 'text-a-blue-2140a6 border-b border-a-blue-2140a6' : 'text-a-gray-a4a4a4']"
                 @click="clickTab('condition')">
                {{lbl.detail.condition}}
            </div>
        </div>
        <div class="pt-3 pb-32 text-a-black-000926 text-14 leading-relaxed" data-cy="container_campaign_content">
            <div v-show="active == 'detail'" v-html="detailText" data-cy="text_campaign_detail_content"></div>
            <div v-show="active == 'condition'" v-html="conditionText" data-cy="text_campaign_condition_content"></div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "DetailAndCondition",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            active: 'detail', // detail, condition

            detailText: null,
            conditionText: null,
        };
    },
    created: function() {
        this.detailText = Util.newLineToBr(this.campaign.detail);
        this.conditionText = Util.newLineToBr(this.campaign.condition);
        this.onTracking();
    },
    methods: {
        clickTab: function(active) {
            this.active = active;
            this.onTracking();
        },
        onTracking: function(){
            if(this.active == 'detail'){
                this.tracking.event('campaign_detail_detail', 'click_detail', this.campaign.id, null);
            }else if(this.active == 'condition'){
                this.tracking.event('campaign_detail_condition', 'click_condition', this.campaign.id, null);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
